/**
 * Klaviyo onsite (browser) configuration.
 *
 * The company ID is PUBLIC — it is the account's public API key and ships in
 * the tracking script URL on every page. Hardcoded for the same reason as the
 * Meta Pixel ID: a missing build-time NEXT_PUBLIC_* var has silently switched
 * client-side integrations off before. Host gating (site-env.ts) is what keeps
 * dev deploys out of the production account, not the absence of a key.
 *
 * The private key (`pk_…`) is a different thing and stays in
 * process.env.KLAVIYO_PRIVATE_KEY, server-only.
 */
export const KLAVIYO_COMPANY_ID = "UmPDCX";

export const KLAVIYO_ONSITE_SCRIPT_ID = "klaviyo-onsite";

/** The script Klaviyo serves for onsite tracking, forms and identify(). */
export function klaviyoOnsiteScriptUrl(companyId = KLAVIYO_COMPANY_ID): string {
  return `https://static.klaviyo.com/onsite/js/${companyId}/klaviyo.js?company_id=${companyId}`;
}
